import axios, { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import {
  CustomAxiosRequestConfig,
  ServerClient,
} from "@core/server/utils/server-client";
import {
  AddGrowingSeasonArguments,
  DeleteReportOperationArguments,
  EditGrowingSeasonArguments,
  GetGrowingSeasonArguments,
  GetGrowingSeasonsArguments,
  GetOperationReportsByCategoryIdArguments,
} from "@/features/growing-season/data/datasources/growing-season-datasources";
import { GetWeatherStationsInRadiusArguments } from "@/features/weather-station/data/datasources/weather-station-datasources";
import {
  GetVisitMarkAsReadArguments,
  GetVisitRequestsArguments,
} from "@/features/Visit/data/datasources/visit-datasources";

import {
  GetExperimentsParametersArguments,
  GetLaboratoryMarkAsReadArguments,
  GetLaboratoryReportsArguments,
  GetLaboratoryRequestsArguments,
  LaboratoriesListArguments,
  sendCostCalculationArguments,
} from "@/features/laboratory/data/datasources/laboratory-datasources";
import { GetWeedsDataArgument } from "@/features/weedless/data/datasources/weedless-datasources";
import {
  DeleteExpertsAccessArguments,
  FindLeadingExpertArgument,
} from "@/features/my-colleagues/data/datasources/my-colleagues-datasources";
import { GetFarmerInvoicesArguments } from "@/features/financial-management/data/datasources/financial-management-datasources";
import { FarmerRegistration } from "@/features/farmer/domain/farmer-interface";
import {
  CalculateCostVisitRequestObject,
  ChillingRequirementRequestObject,
  CultivarRecommendationRequestObject,
  FarmersFieldsRequestObject,
  FirstSaffronIrrigationRequestObject,
  HarvestDataCultivarsRequestObject,
  HarvestDateRecommendationRequestObject,
  OperationsRequestObject,
  ReportOperationObject,
  SowingDateRequestObject,
  VisitRequestObject,
  YieldGapsRequestObject,
  SamplingRequestObject,
  WeedlessObjectArguments,
  AgriculturalMarketPurchaseRequestObjectArguments,
  MyWaterSourcesPoolObjectArguments,
  CalculateVisitObjectArguments,
  WalletPayObject,
  ApplyDiscountObject,
  WalletChargeObjectArguments,
  PaymentObjectArguments,
  FindColleaguesAccessArgument,
  ColleaguesAccessRequestObject,
  LeadingExpertCreateRequestObjectArguments,
  CalculateExperimentObjectArguments,
  ResidentLeadingExpertArgument,
  AdviserExpertsArgument,
  FarmerEditObject,
  FertilizerInquiryObjectArguments,
  PesticideInquiryObjectArguments,
} from "@core/server/domain/request.interface";
import { FieldKey } from "@/shared/components/static-materials/domain/static-materials.interface";
import { API141 } from "./sever-client-experts";
import { LoginPayload } from "@/features/login/domain/interface";
import { GetFertilizerDataArgument, GetPesticideDataArgument } from "@/features/agricultural-market/agricultural-input-purchasing/data/datasources/agricultural-input-purchasing-datasources";

const serverClient = () => ServerClient.Instance();

const farmerId = () =>
  // @ts-ignore
  JSON.parse(localStorage.getItem("profile"))?.id;

//Auth
export async function getProfileApi(farmerId: string) {
  // بعدا چک کنم که parseFarmerProfile کجا استفاده میشه
  // const farmerId =
  //   FarmerId && typeof FarmerId === "string"
  //     ? FarmerId
  //     : parseFarmerProfile()?.id;
  const response = await serverClient().axiosInstance.get(
    `farmers/${farmerId}`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function logoutApi() {
  const response = await serverClient().axiosInstance.delete("/auth/logout");
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function loginApi(phoneNumber: LoginPayload) {
  const response = await serverClient().axiosInstance.post(
    "auth/login",
    phoneNumber
  );
  if (response) {
    console.log("t", response);
    //@ts-ignore
    return response.result.data;
  } else {
    throw new Error();
  }
}

export async function farmerRegistrationApi(farmerInfo: FarmerRegistration) {
  const response = await serverClient().axiosInstance.post(
    `/farmers`,
    farmerInfo
  );
  if (response) {
    return response.data.result;
  } else {
    throw Error();
  }
}

// Farm API
export async function getFarmsApi() {
  const response: AxiosResponse = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/farms`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

// GrowingSeason API
export async function getGrowingSeasonsApi({
  farmId,
  validGrowingSeasons,
}: GetGrowingSeasonsArguments) {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/farms/${farmId}/seasons`,
    {
      params: validGrowingSeasons,
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw Error();
  }
}

export async function getGrwoingSeasonByIdApi({
  farmId,
  seasonId,
}: GetGrowingSeasonArguments) {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/farms/${farmId}/seasons/${seasonId}`
  );
  if (response) {
    return response.data.result;
  } else {
    throw Error();
  }
}

export async function addGrowingSeasonApi({
  season,
  farmId,
}: AddGrowingSeasonArguments) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/farms/${farmId}/seasons`,
    season
  );
  if (response) {
    return response.data.result;
  } else {
    throw Error();
  }
}

export async function editGrowingSeasonApi({
  season,
  farmId,
  seasonId,
}: EditGrowingSeasonArguments) {
  const response = await serverClient().axiosInstance.put(
    `/farmers/${farmerId()}/farms/${farmId}/seasons/${seasonId}`,
    season
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}
//operation
export async function getOperationReportsByCategoryIdApi({
  farmId,
  seasonId,
  categoryId,
}: GetOperationReportsByCategoryIdArguments) {
  const response: AxiosResponse = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/farms/${farmId}/seasons/${seasonId}/operation-reports`,
    {
      params: { categoryId },
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function addReportOperationApi({
  seasonId,
  farmId,
  categoryId,
  typeId,
  data,
}: ReportOperationObject) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/farms/${farmId}/seasons/${seasonId}/operation-reports`,
    {
      data,
      categoryId,
      typeId,
    }
  );
  if (response) {
    return response.data.result;
  } else {
    throw Error();
  }
}

export async function editReportOperationApi({
  seasonId,
  farmId,
  categoryId,
  typeId,
  data,
  operationReportId,
}: ReportOperationObject) {
  const response = await serverClient().axiosInstance.put(
    `/farmers/${farmerId()}/farms/${farmId}/seasons/${seasonId}/operation-reports/${operationReportId}`,
    {
      data,
      categoryId,
      typeId,
    }
  );
  if (response) {
    return response.data.result;
  } else {
    throw Error();
  }
}

export async function deleteReportOperationApi({
  farmId,
  seasonId,
  operationReportId,
}: DeleteReportOperationArguments) {
  const response = await serverClient().axiosInstance.delete(
    `/farmers/${farmerId()}/farms/${farmId}/seasons/${seasonId}/operation-reports/${operationReportId}`
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

//Product API
export async function getProductsApi() {
  const response = await serverClient().axiosInstance.get("/statics/products", {
    showToast: false,
  } as CustomAxiosRequestConfig);
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

// FirstSaffronIrrigation API
export async function getFirstSaffronIrrigationRequestsApi() {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/first-saffron-irrigation-date-recommendations`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function sendFirstSaffronIrrigationRequestApi(
  requestObject: FirstSaffronIrrigationRequestObject
) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/first-saffron-irrigation-date-recommendations`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

// IrrigationSource || myWaterSources
export async function getIrrigationSourceApi() {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/irrigation-sources`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function getPoolListApi() {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/pools`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function createPoolApi(
  requestObject: MyWaterSourcesPoolObjectArguments
) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/pools`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

// IriigationSystem
export async function getIriigationSystemApi() {
  const response = await serverClient().axiosInstance.get(
    "/statics/farmers-fields",
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

//WeatherStations
export async function getWeatherStationsInRadiusApi({
  latitude,
  longitude,
}: GetWeatherStationsInRadiusArguments) {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/weather-stations?latitude=${latitude}&longitude=${longitude}`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw Error();
  }
}

// Visit
export async function getVisitRequestsApi(
  argument?: GetVisitRequestsArguments
) {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/visits${argument?.status ? "?status=" + argument.status : ""
    }`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function calculateCostVisitApi(
  requestObject: CalculateCostVisitRequestObject
) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/visits/calculate-cost`,
    requestObject,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function sendVisitRequestApi(requestObject: VisitRequestObject) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/visits`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function getVisitMarkAsReadApi({
  id,
}: GetVisitMarkAsReadArguments) {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/visits/${id}/mark-as-read`
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

// statics
export async function getFarmersFieldsApi() {
  const response = await serverClient().axiosInstance.get(
    "/statics/farmers-fields",
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function getFarmersFieldsByKeyApi<TKey extends FieldKey>(
  requestObject: FarmersFieldsRequestObject<TKey>
) {
  const response = await serverClient().axiosInstance.get(
    "/statics/farmers-fields",
    {
      params: requestObject,
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

// SowingDate API
export async function getSowingDateRequestsApi() {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/sowing-date-recommendations`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function sendSowingDateRequestApi(
  requestObject: SowingDateRequestObject
) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/sowing-date-recommendations`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

// CultivarRecomendation API
export async function getCultivarRecommendationRequestsApi() {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/cultivar-recommendations`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function sendCultivarRecommendationRequestApi(
  requestObject: CultivarRecommendationRequestObject
) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/cultivar-recommendations`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function getProductsCultivarsApi({
  weatherStationId,
  productId,
}: HarvestDataCultivarsRequestObject) {
  const response = await serverClient().axiosInstance.get(
    `cultivars?productId=${productId}`
  );
  if (response) {
    return response?.data.result;
  } else {
    throw new Error();
  }
}

// export async function getCultivarRecommendationReport(
//   requestObject: cultivarRecommendationId
// ) {
//   const response = await serverClient().axiosInstance.get(
//     `/farmers/${farmerId}/cultivar-recommendations/${cultivarRecommendationId}`,
//     requestObject
//   );
//   if (response) {
//     return response.data.result;
//   } else {
//     throw new Error();
//   }
// }

export async function getProductsParametersApi(id: string) {
  const response = await serverClient().axiosInstance.get(
    `/products-parameters?productId=${id}`
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

// HavestDateRecommendation API
export async function getHarvestDateRecommendationRequestApi() {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/harvest-date-recommendations`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function sendHarvestDateRecommendationRequestApi(
  requestObject: HarvestDateRecommendationRequestObject
) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/harvest-date-recommendations`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

// Chilling-Requirement API
export async function getChillingRequirementRequestsApi() {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/chilling-requirements`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function sendChillingRequirementRequestApi(
  requestObject: ChillingRequirementRequestObject
) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/chilling-requirements`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

// Laboratory API
export async function getLaboratoryRequestsApi(
  argument?: GetLaboratoryRequestsArguments
) {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/experiments${argument?.categoryId ? "?categoryId=" + argument.categoryId : ""
    }${argument?.status ? "?status=" + argument.status : ""}`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function getExperimentParametersApi({
  categoryId,
  typeId,
}: GetExperimentsParametersArguments) {
  const response = await serverClient().axiosInstance.get(
    "/statics/experiments-parameters",
    {
      params: {
        categoryId,
        typeId,
      },
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function sendSamplingRequestApi(
  requestObject: SamplingRequestObject
) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/experiments`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function getLaboratoryReportsApi(
  argument?: GetLaboratoryReportsArguments
) {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/experiments${argument?.status ? "?status=" + argument.status : ""
    }`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function getLaboratoryMarkAsReadApi({
  experimentId,
}: GetLaboratoryMarkAsReadArguments) {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/experiments/${experimentId}/mark-as-read`
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function costCalculateLaboratoryApi({
  typeId,
  categoryId,
  parametersIds,
}: sendCostCalculationArguments) {
  const response = await serverClient().axiosInstance.post(
    "/laboratories/calculate-cost",
    { typeId, categoryId, parametersIds },
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function laboratoriesListApi({
  typeId,
  categoryId,
  parametersIds,
}: LaboratoriesListArguments) {
  const response = await serverClient().axiosInstance.post(
    "/laboratories/laboratories-list",
    { typeId, categoryId, parametersIds },
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

// yieldGaps API
export async function getYieldGapsRequestsApi() {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/yield-gaps`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function sendYieldGapsRequestApi(
  requestObject: YieldGapsRequestObject
) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/yield-gaps`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function getYieldGapJsonQuestionsApi(productId: number) {
  const response = await serverClient().axiosInstance.get(
    `/samples/yield-gap/${productId}`
  );
  if (response) {
    const responseJson = axios.get(
      response.data.result.data.sample.data.files[0]
    );
    return responseJson;
  } else {
    throw new Error();
  }
}

// Operations API
export async function getOperationsRequestsApi() {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/***`
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function sendOperationsRequestApi(
  requestObject: OperationsRequestObject
) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/***`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

// NutritionProgram API
export async function getNutritionProgramRequestsApi() {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/questionnaires`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

// Weedless API
export async function getWeedlessRequestsApi() {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/prescriptions`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function getWeedsApi({
  page,
  limit,
  name,
  typeId,
  productId,
}: GetWeedsDataArgument) {
  const response = await serverClient().axiosInstance.get(`/weeds`, {
    params: { name, page, productId, limit, typeId },
    showToast: false,
  } as CustomAxiosRequestConfig);
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function sendCartWeedApi(requestObject: WeedlessObjectArguments) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/prescriptions`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

// get expert API
export async function getLeadingExpertsApi() {
  const response = await serverClient().axiosInstance.get("/leading-experts", {
    showToast: false,
  } as CustomAxiosRequestConfig);
  if (response) {
    return response?.data.result;
  } else {
    throw new Error();
  }
}

// agricultural-market API
export async function getAgriculturalInputInquiriesApi() {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/agricultural-input-supply-inquiries`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function getFertilizersApi({
  page,
  name,
  limit,
  fertilizersTitleIds,
}: GetFertilizerDataArgument) {
  const params: GetFertilizerDataArgument = { page, name, limit };
  if (fertilizersTitleIds) {
    params.fertilizersTitleIds = fertilizersTitleIds;
  }
  const response = await serverClient().axiosInstance.get(
    `/fertilizers-varieties`,
    {
      params,
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function sendFertilizerInquiryApi(
  requestObject: FertilizerInquiryObjectArguments
) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/agricultural-input-supply-inquiries`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function getPesticidesApi({
  q,
  usageId,
  page,
  limit,
}: GetPesticideDataArgument) {
  const params: GetPesticideDataArgument = { q, page, limit };
  if (usageId) {
    params.usageId = usageId;
  }
  const response = await serverClient().axiosInstance.get(
    `/pesticides`,
    {
      params,
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function sendPesticideInquiryApi(
  requestObject: PesticideInquiryObjectArguments
) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/agricultural-input-supply-inquiries`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function getAgriculturalInputStaticsApi() {
  const response = await serverClient().axiosInstance.get(
    "/statics/farmers-fields",
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function sendPurchaseRequestApi(
  requestObject: AgriculturalMarketPurchaseRequestObjectArguments
) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/agricultural-input-purchase-requests`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}
//farmer fields API

export async function registerFarmApi() {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/farms`
  );
  if (response) {
    const sucsses = response?.data?.result?.message;
    toast.success(sucsses);
    return response?.data?.result?.data;
  }
}

export async function updateFieldApi(data: any) {
  const response = await serverClient().axiosInstance.put(
    `/farmers/${farmerId()}/farms/${data?.farmId}`,
    data?.editedData
  );
  if (response) {
    const sucsses = response?.data?.result?.message;
    toast.success(sucsses);
    return response?.data;
  } else {
    throw new Error();
  }
}

export async function growingSeasonFieldApi({
  growingSeasonData,
  farmId,
}: any) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/farms/${farmId}/seasons`,
    growingSeasonData
  );
  if (response) {
    const sucsses = response?.data?.result?.message;
    toast.success(sucsses);
    return response?.data?.result?.data;
  } else {
    throw Error();
  }
}

// export async function getDataAllCertificateApi(farmId: string) {
//   const response = await serverClient().axiosInstance.get(
//     `/farmers/${farmerId()}/farms/${farmId}/history`
//   );
//   if (response) {
//     // return response?.result?.data
//   } else {
//     throw new Error();
//   }
// }

export async function deleteFieldsApi(farmId: string) {
  const response = await serverClient().axiosInstance.delete(
    `/farmers/${farmerId()}/farms/${farmId}`
  );
  if (response) {
    const sucsses = response?.data?.result?.message;
    toast.success(sucsses);
    return response?.data?.result;
  } else {
    throw new Error();
  }
}

export async function getStaticCitiesApi() {
  const response = await serverClient().axiosInstance.get("/statics/cities", {
    showToast: false,
  } as CustomAxiosRequestConfig);
  if (response) {
    return response?.data?.result;
  }
}

export async function getStaticProvincesApi() {
  const response = await serverClient().axiosInstance.get(
    "/statics/provinces",
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response?.data?.result;
  } else {
    throw new Error();
  }
}

// my-colleagues API
export async function getExpertsAccessApi() {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/experts-access`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function deleteExpertsAccessApi({
  accessId,
}: DeleteExpertsAccessArguments) {
  const response = await serverClient().axiosInstance.delete(
    `/farmers/${farmerId()}/experts-access/${accessId}`
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function findLeadingExpertApi({
  phoneNumber,
}: FindLeadingExpertArgument) {
  const response = await serverClient().axiosInstance.get(
    `/leading-experts/inquiry`,
    {
      params: { phoneNumber },
    }
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function deleteResidentLeadingExpertApi(
  residentLeadingExpertId: string
) {
  const response = await serverClient().axiosInstance.delete(
    `/farmers/${farmerId()}/resident-leading-experts/${residentLeadingExpertId}`
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function findColleaguesAccessApi({
  expertQuery,
}: FindColleaguesAccessArgument) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/experts-access/search`,
    {
      expertQuery,
    }
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function getResidentLeadingExpertApi(
  queryKey: ResidentLeadingExpertArgument
) {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/resident-leading-experts`,
    {
      params: queryKey,
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function createLeadingExpertApi(leadingExpertId: string) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/resident-leading-experts`,
    { leadingExpertId }
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function createColleaguesAccessApi(
  requestObject: ColleaguesAccessRequestObject
) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/experts-access`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function editColleaguesAccessApi(
  accessId: string,
  requestObject: ColleaguesAccessRequestObject
) {
  const response = await serverClient().axiosInstance.put(
    `/farmers/${farmerId()}/experts-access/${accessId}`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function leadingExpertCreateRequestApi(
  requestObject: LeadingExpertCreateRequestObjectArguments
) {
  const response = await serverClient().axiosInstance.post(
    `/leading-experts/create-request`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function pricingCalculateVisitApi(
  requestObject: CalculateVisitObjectArguments
) {
  const response = await serverClient().axiosInstance.post(
    `/pricing/visits/calculate`,
    requestObject,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function pricingCalculateExperimentApi(
  requestObject: CalculateExperimentObjectArguments
) {
  const response = await serverClient().axiosInstance.post(
    `/pricing/experiments/calculate`,
    requestObject,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function getAdviserExpertsApi(queryKey: AdviserExpertsArgument) {
  const response = await serverClient().axiosInstance.get(`/adviser-experts`, {
    params: queryKey,
    showToast: false,
  } as CustomAxiosRequestConfig);
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function getAdviserStaticsApi() {
  const response = await serverClient().axiosInstance.get(
    `/statics/adviser-experts`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

//financial-management
export async function getFarmerInvoicesApi(args?: GetFarmerInvoicesArguments) {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/invoices`,
    {
      params: args,
      showToast: false,
    } as CustomAxiosRequestConfig
  );

  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function getFarmerDiscountsApi() {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/discounts`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );

  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function walletBalanceApi() {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/wallets/info`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );

  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function getWalletTransactionsApi() {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/wallets/transactions`,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );

  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

//Payments
export async function getFarmerInvoiceApi(invoiceId: string) {
  const response = await serverClient().axiosInstance.get(
    `/farmers/${farmerId()}/invoices/${invoiceId}`
  );

  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function walletPayApi(requestObject: WalletPayObject) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/wallets/pay`,
    requestObject,
    {
      showToast: true,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function applyDiscountApi(requestObject: ApplyDiscountObject) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/discounts/apply`,
    requestObject,
    {
      showToast: true,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function walletChargeApi(
  requestObject: WalletChargeObjectArguments
) {
  const response = await serverClient().axiosInstance.post(
    `/farmers/${farmerId()}/wallets/charge`,
    requestObject,
    {
      showToast: false,
    } as CustomAxiosRequestConfig
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function paymentsApi(requestObject: PaymentObjectArguments) {
  const response = await serverClient().axiosInstance.post(
    `/payments`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

// counter
export async function serverDateApi() {
  const response = await serverClient().axiosInstance.get(`/statics/datetime`, {
    showToast: false,
  } as CustomAxiosRequestConfig);
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}

export async function getNearExpertsApi() {
  const profile = localStorage.getItem("profile");
  const farmer = profile ? JSON.parse(profile) : {};

  let queryString = "/experts?limit=10";
  if (farmer?.provinceId) {
    queryString += `&provinceId=${farmer.provinceId}`;
  }

  const response = await API141().get(queryString);
  if (response) {
    return response.data;
  } else {
    throw new Error();
  }
}


export async function editFarmerStatusApi(requestObject: FarmerEditObject) {
  const response = await serverClient().axiosInstance.put(
    `/farmers/${farmerId()}`,
    requestObject
  );
  if (response) {
    return response.data.result;
  } else {
    throw new Error();
  }
}
